import { ColumnDef } from '@tanstack/react-table';

import { WebEDIRowData } from 'support/types/webediTable';
import { xlsxLoader } from 'components/Form/FileInput/Loaders/xlsxLoader/xlsxLoader';

export const createLoader = (dataStartRowNumber: number) => {
  return xlsxLoader({
    global: {
      headerRowNumber: 2,
      dataStartRowNumber,
    },
    processHiddenSheets: true,
    hiddenSheets: {
      headerRowNumber: 1,
    },
  });
};

/**
 * Creates an Excel loader configured based on column structure
 * Automatically calculates the correct data start row:
 * - Row 5 for flat columns (no embedded table structure)
 * - Row 6 for embedded table columns (includes sub-header row)
 *
 * @param columns - Column definitions from TanStack Table
 * @returns Configured XLSX loader
 */
export const createLoaderForColumns = (columns: Array<ColumnDef<WebEDIRowData, unknown>>) => {
  const hasEmbeddedTableColumns = columns.some(
    (col) => 'columns' in col && Array.isArray(col.columns) && col.columns.length > 0,
  );
  const dataStartRowNumber = hasEmbeddedTableColumns ? 6 : 5;

  return createLoader(dataStartRowNumber);
};
